// src/pages/ForgotPassword.jsx
import { useState } from 'react';
import api from '../api';
import './AuthForm.css';
import Footer from '../components/Footer';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/auth/forgot-password', { email });
      setMessage(res.data.msg);
    } catch (err) {
      setMessage(err.response?.data?.msg || 'Erreur');
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      <main className="flex-1 flex items-center justify-center p-6">
        <form className="auth-form" onSubmit={handleSubmit}>
          <h2>Mot de passe oublié</h2>
          <input
            type="email"
            placeholder="Votre adresse email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="btn-primary w-full">Envoyer le lien</button>
          {message && <p className="info-text">{message}</p>}
        </form>
      </main>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
